import { assert } from '@ember/debug';

function isFastBoot(owner) {
  assert('You must pass in an owner to isFastBoot!', owner && typeof owner.lookup === 'function');
  const fastboot = owner.lookup('service:fastboot');
  return fastboot ? fastboot.get('isFastBoot') : false;
}

export { isFastBoot as default };
//# sourceMappingURL=is-fastboot.js.map
